import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AppService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root'
})
export class CustomOktaAuthGuard implements CanActivate {
  constructor(
    @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth,
    private readonly router: Router,
    private readonly appService: AppService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isAuthenticated = await this.oktaAuth.isAuthenticated();
    
    if (isAuthenticated) {
      return true;
    }

    const fromGateway = sessionStorage.getItem('fromGateway');
    if (fromGateway === 'true') {
      sessionStorage.removeItem('fromGateway');
      
      this.oktaAuth.setOriginalUri(state.url);
      await this.oktaAuth.signInWithRedirect();
      return false;
    }

    this.oktaAuth.setOriginalUri(state.url);
    
    sessionStorage.setItem('fromGateway', 'true');
    
    const config = this.appService.readConfig();
    const currentOrigin = window.location.origin;
    const loginUrl = encodeURIComponent(currentOrigin);
    const gatewayUrl = `${config.gatewayLoginUrl}?loginUrl=${loginUrl}`;
    
    window.location.href = gatewayUrl;
    
    return false;
  }
}
